import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './Comments.css';
import { FormControl, InputGroup, Button } from 'react-bootstrap';
import moment from 'moment'

class Comment extends Component {
    render() {
        const isQuestionCreator = this.props.questionCreatedByUuid === this.props.comment.createdByUuid;
        return (
            <div className="comment-container">
                {isQuestionCreator &&
                    <div className="icon-container" title="Question Author">
                        <FontAwesomeIcon icon="user-edit" size="2x"/>
                    </div>
                }
                {!isQuestionCreator &&
                    <div className="icon-container" title="Question Auditor">
                        <FontAwesomeIcon icon="glasses" size="2x"/>
                    </div>
                }
                <div className="comment-body-container">
                    <div className="created-info">
                        <span className="comment-username">
                            {this.props.comment.username || 'Unknown user'}
                        </span>
                        <span className="comment-created-date">
                            {moment(this.props.comment.createdDate || new Date(0)).format("YYYY-MM-DD, h:mm:ss a") }
                        </span>
                    </div>
                    <div className="comment-text">
                        {this.props.comment.text}
                    </div>
                </div>
            </div>
        );
    }
}

class Comments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            value: '',
            userPromises: {}
        };
        this.mixinUserData = this.mixinUserData.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {
        const self = this;
        Promise.all(this.props.comments.map((comment) => {
            return self.mixinUserData(comment);
        }))
        .then(() => {
            self.setState({loading: false});
        });
    }
    mixinUserData(comment) {
        const self = this;
        if (!self.state.userPromises[comment.createdByUuid]) {
            self.state.userPromises[comment.createdByUuid] = self.props.qBankApi.getUser(comment.createdByUuid);
        }

        self.state.userPromises[comment.createdByUuid].then((user) => {
            comment.username = user.username;
        });
    }
    handleChange(event) {
        this.setState({value: event.target.value});
    }
    handleSubmit(event) {
        const self = this;
        this.props.qBankApi.createQuestionComment(this.props.questionId, {'text': this.state.value})
        .then((comment) => {
            self.setState({value: ''});
            comment.username = this.props.me.username;
            self.props.addComment(comment);
        });
        event.preventDefault();
    }
    render() {
        if (!this.props.questionId || this.props.questionId === "new") {
            return (
                <div className="comments-container">Comments cannot be added to this question, because it has not yet been saved.</div>
            )
        }

        return (
            <form className="comments-container" onSubmit={this.handleSubmit}>
                <div>
                    {
                        this.props.comments.map((comment) => {
                            return (
                                <Comment me={this.props.me} questionCreatedByUuid={this.props.questionCreatedByUuid} key={comment.uuid} comment={comment}/>
                            );
                        })
                    }
                </div>
                <InputGroup>
                    <FormControl
                        className="comment-input"
                        placeholder="Type your message"
                        type="text"
                        value={this.state.value}
                        onChange={this.handleChange}
                    />
                    <InputGroup.Button>
                        <Button type="submit" bsStyle="primary">Send</Button>
                    </InputGroup.Button>
                </InputGroup>
            </form>
        );
    }
}

export default Comments;
